export const CAR_API_BASE_URL = "https://65d24788987977636bfc333b.mockapi.io/api/cars";
export const USER_API_BASE_URL = "https://65d24788987977636bfc333b.mockapi.io/api/users";
